import { render, staticRenderFns } from "./CampaignSpecifiedChartDetailsTable.vue?vue&type=template&id=7fb4c3e2&scoped=true&"
import script from "./CampaignSpecifiedChartDetailsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignSpecifiedChartDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4c3e2",
  null
  
)

export default component.exports